import { useParams } from 'react-router-dom';
import PaymentVerify from './payment-verify';
import Error from '../shared/error';
import { APIErrorType } from '../../api';
import Loader from '../shared/loader';
import { usePayment } from '../../hooks/react-query/use-payment';

export type PaymentVerifyContainerPropsType = {
  code: string;
};

function PaymentVerifyContainer({ code }: PaymentVerifyContainerPropsType) {
  const { paymentId } = useParams();

  const {
    isError,
    isLoading,
    data: payment,
    error
  } = usePayment(paymentId ? parseInt(paymentId) : undefined);

  if (isError) return <Error error={error as APIErrorType} />;
  if (isLoading || !payment) return <Loader />;

  return <PaymentVerify payment={payment} />;
}

export default PaymentVerifyContainer;
